import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { IdcardOutlined } from '@ant-design/icons'
import { ContactContext } from 'contexts/contactContext'
import dayjs from 'dayjs'

import {
  DisplayCard,
  Link,
  InformationWrapper,
  Col,
  Row,
  DisplayCardTitleWrapper,
} from './styles'

const CustomerInformations = () => {
  const { t } = useTranslation()
  const { contact } = useContext(ContactContext)
  const domiciliation = contact.domiciliation

  const contactTitle = (
    <DisplayCardTitleWrapper className={'blue'}>
      <IdcardOutlined />
      {` ${t('contact:resume.cards.informations.title')}`}
      {` [${contact.id}]`}
    </DisplayCardTitleWrapper>
  )

  return (
    <DisplayCard
      title={contactTitle}
      extra={
        domiciliation && (
          <Link href={`/admin2/admin/customers/${domiciliation.id}`}>
            {t('contact:resume.cards.informations.domiciliation_link')}
          </Link>
        )
      }
    >
      <InformationWrapper>
        <Col>
          <Row>
            <span>{t('contact:resume.cards.informations.leader')}</span>
            <span>
              {`${domiciliation?.contactDetail?.firstname} ${domiciliation?.contactDetail?.lastname}`}
            </span>
          </Row>
          <Row>
            <span>
              {t('contact:resume.cards.informations.leader_mandataire')}
            </span>
            <span>KEZAKO</span>
          </Row>
          <Row>
            <span>{t('contact:resume.cards.informations.phone_number')}</span>
            <span>{domiciliation?.contactDetail?.phoneNumber}</span>
          </Row>
          <Row>
            <span>{t('contact:resume.cards.informations.email')}</span>
            <span>{domiciliation?.contactDetail?.email}</span>
          </Row>
        </Col>

        <Col>
          <Row>
            <span>{t('contact:resume.cards.informations.society.name')}</span>
            <span>{domiciliation?.society?.name}</span>
          </Row>
          <Row>
            <span>
              {t('contact:resume.cards.informations.society.brand_name')}
            </span>
            <span>{domiciliation?.society?.brandName || 'N/A'}</span>
          </Row>
          <Row>
            <span>
              {t('contact:resume.cards.informations.society.legal_status')}
            </span>
            <span>{domiciliation?.society?.legalStatus?.name}</span>
          </Row>
          <Row>
            <span>
              {t('contact:resume.cards.informations.society.activity')}
            </span>
            <span>{domiciliation?.society?.activity}</span>
          </Row>
        </Col>

        <Col>
          <Row>
            <span>
              {t('contact:resume.cards.informations.inscription_date')}
            </span>
            <span>
              {contact.clientSince
                ?.dayjs(contact.clientSince)
                ?.format('DD/MM/YYYY')}
            </span>
          </Row>
          <Row>
            <span>{t('contact:resume.cards.informations.sale')}</span>
            <span>TODO</span>
          </Row>
        </Col>
      </InformationWrapper>
    </DisplayCard>
  )
}

export default CustomerInformations
